import name from './name'

const selectSliceData = state => state[name]
const selectCatalogList = state => selectSliceData(state).catalogList
const selectCatalogListTotal = state => selectSliceData(state).catalogListTotal

export { selectCatalogList, selectCatalogListTotal }
